import { themes } from 'kb-shared';
import styled from 'styled-components';

const { colors, queries } = themes;

export const StepContent = styled.div`
  color: ${colors.neutral.primaryNavy};
  cursor: default;
  margin-top: 2px;
  margin-right: 28px;
  margin-bottom: 28px;

  @media ${({ theme }) => theme.queries.minTablet} {
    margin: 2px 48px;
  }

  @media ${({ theme }) => theme.queries.minDesktop} {
    margin: 2px 96px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  background: white;
  flex-direction: column;
  position: relative;
  margin: 2px 0;
  padding-right: 24px;

  @media ${({ theme }) => theme.queries.minTablet} {
    flex-direction: row;
  }
`;

export const TimelineWrapper = styled.div`
  position: absolute;
  padding-top: 30px;
  top: 0;
  bottom: 0;
  left: 16px;

  @media screen and ${queries.minTablet} {
    padding-top: 18px;
    margin-left: 54px;
  }

  @media screen and ${queries.minDesktop} {
    padding-top: 18px;
    margin-left: 108px;
  }
`;

export const TodoBlock = styled.div`
  margin-left: 70px;
  padding-top: 34px;
  padding-bottom: 28px;

  @media screen and ${queries.minTablet} {
    padding-bottom: 0px;
    padding-top: 18px;
    margin-left: 173px;
    width: 100%;
  }
`;
